var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-group w-full",
    class: _vm.$attrs.class,
    style: _vm.$attrs.style
  }, [_c('ValidationProvider', _vm._b({
    attrs: {
      "name": _vm.name,
      "rules": _vm.rules
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_vm.label ? _c('label', {
          staticClass: "block text-base font-normal mb-1",
          class: _vm.labelClass
        }, [_vm._v(_vm._s(_vm.label) + " "), _vm.isRequired ? _c('b', {
          staticClass: "ml-1 text-red-600 font-bold"
        }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _c('div', {
          staticClass: "relative input-group"
        }, [_vm.leftIcon ? _c('div', {
          staticClass: "icon-left"
        }, [_c('i', {
          class: _vm.leftIcon
        })]) : _vm._e(), _c('input', _vm._b({
          class: ['form-control', _vm.leftIcon ? 'pl-10' : '', _vm.rightIcon ? 'pr-10' : '', _vm.inputClass, _vm.value !== '' ? 'bg-white' : 'bg-gray-100'],
          attrs: {
            "type": _vm.inputType,
            "autocomplete": "off"
          },
          domProps: {
            "value": _vm.value
          },
          on: {
            "input": _vm.onChange,
            "keyup": _vm.onKeyUp
          }
        }, 'input', _vm.$attrs, false)), _vm.rightIcon ? _c('div', {
          staticClass: "icon-right",
          on: {
            "click": function ($event) {
              return _vm.$emit('rightIconClick');
            }
          }
        }, [_c('i', {
          class: _vm.rightIcon
        })]) : _vm._e(), _vm.isPasswordType ? _c('div', {
          staticClass: "icon-right cursor-pointer",
          class: _vm.rightIcon ? 'mr-6' : '',
          on: {
            "click": _vm.togglePassword
          }
        }, [_c('i', {
          class: _vm.showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'
        })]) : _vm._e(), _vm._t("right-icon")], 2), !!_vm.hint ? _c('span', {
          staticClass: "text-xs text-gray-400",
          class: _vm.hintClass
        }, [_vm._v(_vm._s(_vm.hint))]) : _vm._e(), _c('span', {
          staticClass: "text-xs text-red-600"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, true)
  }, 'ValidationProvider', _vm.$attrs, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }